import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "wrapper-friends-view"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderCircle = _resolveComponent("LoaderCircle")!
  const _component_ProfileHeader = _resolveComponent("ProfileHeader")!
  const _component_ProfileFriendsRecipes = _resolveComponent("ProfileFriendsRecipes")!
  const _component_ProfileFriendsFriends = _resolveComponent("ProfileFriendsFriends")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_LoaderCircle, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ProfileHeader, {
          user: _ctx.friend,
          "profile-picture-editable": false
        }, null, 8, ["user"]),
        _createVNode(_component_ProfileFriendsRecipes, {
          friend: _ctx.friend,
          "horizontal-slide": true
        }, null, 8, ["friend"]),
        _hoisted_2,
        _createVNode(_component_ProfileFriendsFriends, {
          friend: _ctx.friend,
          "horizontal-slide": true
        }, null, 8, ["friend"])
      ]))
}